import React from 'react'
import { Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import { useTranslation } from '@flows-ui/utils/i18n'
import Spacer from '@ui-kit/components/layoutComponents/Spacer'
import { body2, h3, h4 } from '@ui-kit/core/typography'

const successStepStyles = tv({
  slots: {
    container: 'flex w-full max-w-[440px] flex-col items-center self-center py-12',
    heart: 'mb-4 text-[64px]',
    title: h3({ align: 'center' }),
    subtitle: body2({ color: 'grey700', align: 'center' }),
    downloadAppTitle: h4({ align: 'center' }),
  },
})

export const SuccessStep = () => {
  const { t } = useTranslation()
  const styles = successStepStyles()

  return (
    <View className={styles.container()}>
      <Text className={styles.heart()}>\u2764\uFE0F</Text>
      <Text className={styles.title()}>{t('sharedFlows_common:steps.success.purchase.title')}</Text>
      <Spacer size="small" />
      <Text className={styles.subtitle()}>{t('sharedFlows_common:steps.success.subtitle')}</Text>
      <Spacer size="large" />
      <Text className={styles.downloadAppTitle()}>
        {t('sharedFlows_common:steps.success.downloadApp')}
      </Text>
    </View>
  )
}
